import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=a96f582a&scoped=true"
import script from "./infrastructure.vue?vue&type=script&lang=js"
export * from "./infrastructure.vue?vue&type=script&lang=js"
import style0 from "./infrastructure.vue?vue&type=style&index=0&id=a96f582a&prod&lang=scss&scoped=true"
import style1 from "./infrastructure.vue?vue&type=style&index=1&id=a96f582a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96f582a",
  null
  
)

export default component.exports